import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Sectioned form card used by the Create User / Edit User redesign:
 * icon + title header row, divider, padded content. Colors come from
 * theme tokens so it renders correctly in both dark and light shells.
 */
interface FormSectionProps {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
  className?: string;
}

const FormSection = ({ icon: Icon, title, children, className }: FormSectionProps) => (
  <section className={cn('rounded-xl border border-border bg-card/40', className)}>
    <div className="flex items-center gap-2.5 border-b border-border px-5 py-4">
      <Icon className="h-[18px] w-[18px] text-primary/80" />
      <h3 className="text-base font-semibold">{title}</h3>
    </div>
    <div className="px-5 py-5 space-y-4">{children}</div>
  </section>
);

export default FormSection;
